import _ from 'lodash';
import createAccentInsensitiveRegex from './createAccentInsensitiveRegex.js';

export default function buildSearchWordsExpression(words, fields, isNegated) {
  if (_.size(words) === 0) {
    return;
  }

  return {
    $and: _.map(words, word => createExpression(word, fields, isNegated))
  };
}

function createExpression(word, fields, isNegated) {
  if (isNegated) {
    return {
      $and: _.map(fields, field => ({
        [field]: {
          $not: {
            $regex: createAccentInsensitiveRegex(word),
            $options: 'i'
          }
        }
      }))
    };
  } else {
    return {
      $or: _.map(fields, field => ({
        [field]: {
          $regex: createAccentInsensitiveRegex(word),
          $options: 'i'
        }
      }))
    };
  }
}
